import React from "react";
import { useQuickSightEFS } from "@/hooks/useEFSReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsEFSDashboard from "@/components/organisms/EFSDashboard";

function EFSReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightEFS();

  return (
    <AWSReportsTemplate
      title="AWS EFS Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsEFSDashboard />
    </AWSReportsTemplate>
  );
}

export default EFSReports;
